/*
 * @Author: zhangsheng
 * @Date: 2023-09-18 16:17:15
 * @LastEditors: zhangsheng
 * @LastEditTime: 2023-10-07 16:48:14
 * @FilePath: \panda-index-sicermem-frontend\src\locales\en-US\product.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
export default {
  'components.ProductIntroduce.976335-1': 'Product Parameters',
  'components.ProductIntroduce.976335-2': 'Product Introduction',
  'components.ProductIntroduce.976335-3': 'Technical Parameter',
  'components.ProductIntroduce.976335-4': 'Product Advantages',
  'components.ProductIntroduce.976335-5': 'W membrane element',
  'components.ProductIntroduce.976335-6': 'See More',
  'components.ProductIntroduce.976335-7': 'Retract',
  'components.ProductIntroduce.976335-8': 'Return',
  'components.ProductIntroduce.976335-9': '/en/product',
  'components.ProductIntroduce.976335-10': '/en/product/detail',
};
